<template>
    <div :class="getClass">
        <label :for="id">{{label}}</label>
        <input 
            v-if="!hasIcon"
            type="text" 
            :id="id" 
            class="form-control" 
            :value="value" 
            :placeholder="placeholder"
            @input="$emit('input', $event.target.value)"
        />
        <div v-if="hasIcon" class="input-group">
            <div v-if="iconPrepend" class="input-group-prepend">
                <div class="input-group-text">
                    <font-awesome-icon :icon="['fad', iconPrepend]" fixed-width></font-awesome-icon>
                </div>
            </div>
            <input 
                v-if="hasIcon"
                type="text" 
                :id="id" 
                class="form-control" 
                :value="value" 
                :placeholder="placeholder"
                @input="$emit('input', $event.target.value)"
            />
            <div v-if="iconAppend" class="input-group-append">
                <div class="input-group-text">
                    <font-awesome-icon :icon="['fad', iconAppend]" fixed-width></font-awesome-icon>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        value: String,
        id: String,
        label: String,
        class: String,
        placeholder: String,
        iconPrepend: String,
        iconAppend: String
    },
    computed: {
        getClass() {
            return this.class ? 'form-group ' + this.class : 'form-group'
        },
        hasIcon() {
            return this.iconPrepend || this.iconAppend
        }
    }
}
</script>
<style lang="scss" scoped>
@import '../../styles/bootstrap/_custom';

.input-group-text {
    color: $success;
}

</style>


// WEBPACK FOOTER //
// src/components/forms/text-input.vue